import { render, staticRenderFns } from "./trainAccountStatus.vue?vue&type=template&id=19b295ca&scoped=true&"
import script from "./trainAccountStatus.vue?vue&type=script&lang=ts&"
export * from "./trainAccountStatus.vue?vue&type=script&lang=ts&"
import style0 from "./trainAccountStatus.vue?vue&type=style&index=0&id=19b295ca&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b295ca",
  null
  
)

export default component.exports